import { isAxiosError } from 'axios';

import { isRecord } from 'app/modules/wallforming/components/copilot/utils/copilotUtils';

export const MAX_PLAN_FILES = 10;
export const MAX_PLAN_TOTAL_BYTES = 50 * 1024 * 1024;
export const PLAN_FILE_ACCEPT =
    '.pdf,.png,.jpg,.jpeg,.webp,.gif,application/pdf,image/png,image/jpeg,image/webp,image/gif';

/** Reads a file as base64 without the data-URL prefix. */
export const readFileAsBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = typeof reader.result === 'string' ? reader.result : '';
            resolve(result.slice(result.indexOf(',') + 1));
        };
        reader.onerror = () => reject(reader.error ?? new Error(`Could not read ${file.name}.`));
        reader.readAsDataURL(file);
    });

export const isPdfFile = (file: File) => file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
export const isPlanFile = (file: File) => /\.(pdf|png|jpe?g|webp|gif)$/i.test(file.name);
export const formatMegabytes = (bytes: number) => `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

/** Extracts the Problem Details message and validation/conversion errors from a failed request. */
export const getProblemMessages = (error: unknown): { detail: string; errors: string[] } => {
    const problem = isAxiosError<unknown>(error) ? error.response?.data : undefined;
    if (!isRecord(problem)) {
        return { detail: '', errors: [] };
    }

    const detail = typeof problem.detail === 'string' ? problem.detail.trim() : '';
    const rawErrors = problem.errors;
    const errors = Array.isArray(rawErrors)
        ? rawErrors.filter((entry): entry is string => typeof entry === 'string')
        : isRecord(rawErrors)
          ? Object.values(rawErrors).flatMap((entry) =>
                Array.isArray(entry) ? entry.filter((item): item is string => typeof item === 'string') : []
            )
          : [];
    return { detail, errors };
};
